<template>
  <!-- 评论管理详情页 -->
  <div class="commentDetail">
    <HeadTitle :url="url"></HeadTitle>
    <!-- <HeadTopComment :headTitle="$route.meta.title"></HeadTopComment> -->
    <div style="margin-top: 50px">
      <div class="topBox">
        <div class="text" @click="goViewPost">查看原帖</div>
      </div>
      <div class="box" style="height: 150px" v-for="(item, index) in list" :key="index">
        <div class="topRow">
          <div class="topRowLeft">
            <div>
              <img class="touXiangImg" :src="img" mode="" />
            </div>
            <div class="headLeft">
              <div class="name">
                {{ item.author }}
              </div>
              <div>
                <div class="uid">uid:{{ uid }}</div>
              </div>
            </div>
          </div>
          <div class="topRowRight">
            <div>
              <span :style="{ 'color': caseFieldColorValue() }">{{ caseFieldValue() }}</span>
            </div>
          </div>
          <!-- <div class="topRowRight">{{ item.state }}</div> -->
        </div>
        <div class="contentBottom">
          <span v-if="item.isReply">
            回复
            <span style="color: #1699d2"> {{ item.replyName }} </span>:</span>
          <span> {{ item.content }}</span>
        </div>
        <div class="timeBox">
          <div class="time">
            {{ item.date }}
          </div>
          <div class="operation">
            <van-button plain size="mini" @click="deleteCom(item, true)" style="
                            padding: 0px 8px 0px 5px;
                            border: 1px solid #179ad2;
                            color: #179ad2;
                          ">删除</van-button>
          </div>
        </div>
      </div>
      <div v-if="ispinglun" class="replyBox">
        <van-divider content-position="left"
          :style="{ color: 'black', fontWeight: '600', fontSize: '0.42667rem', borderColor: 'black' }">
          {{ listData.length }}条评论
        </van-divider>
      </div>
      <div v-if="listData.length === 0" class="van-empty">
        <div class="van-empty__image"><img src="../../assets/icon/empty-image-default.png"></div>
        <p class="van-empty__description">暂无评论</p>
      </div>
      <div class="box" style="height: 100px" v-for="item in listData" :key="item.id">
        <div class="topRow">
          <div class="topRowLeft">
            <div class="headLeft">
              <div class="name">
                {{ item.author }}
              </div>
            </div>
          </div>
        </div>
        <div class="contentBottom">
          <span v-if="item.isReply">
            回复
            <span style="color: #567cc5"> {{ item.replyName }} </span>:</span>
          <span> {{ item.content }}</span>
        </div>
        <div class="timeBox">
          <div class="time">
            {{ item.date }}
          </div>
          <div class="operation">
            <!-- type="info" -->
            <van-button size="mini" @click="deleteCom(item, false)" style="
                            padding: 0px 8px 0px 5px;
                            border: 1px solid #179ad2;
                            color: #179ad2;
                          ">删除</van-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 固定底部的操作按钮 -->
    <div class="btnBoottom">
      <div class="operationBtn">
        <div v-if="ispinglun" @click="comment" class="btn1">评论</div>
        <div v-if="isStatus" @click="pass" class="btn2">通过</div>
        <div v-if="isStatus" @click="fail" class="btn2">不通过</div>
      </div>
    </div>
    <!-- 底部弹框 -->
    <van-popup v-model="showPopup" position="bottom" round :style="{ height: '40%' }">
      <div class="commonPop">
        <div class="titleTop">管理员评论</div>
        <van-field label="PGC账号" readonly v-model="circle" is-link @focus="showCircle = true" style="font-size: 16px"></van-field>
        <van-action-sheet v-model="showCircle" :round="false" :actions="selectList" @select="onSelect"></van-action-sheet>
        <van-field v-model="textMess" rows="6" autosize label="评论" type="textarea" placeholder="请输入评论文字内容(最多5000字)" />
        <div class="btnRow">
          <van-button type="default" block hairline round style="
                          width: 150px;
                          color: rgb(72, 113, 192);
                          border: 1px solid rgb(72, 113, 192);
                        " @click="cancelCircle">取消</van-button>
          <van-button block hairline round style="width: 150px; background: rgb(72, 113, 192); color: white"
            @click="oKCircle">确认</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {
  deleteReplyForumCommentAPI,
  replylistForumCommentAPI,
  addCommentAPI,
  commentauditForumCommentAPI,
} from "@/api/commentManagement";
import { Dialog, Toast } from "vant";
import HeadTitle from "../../components/HeadTitle";
// import HeadTopComment from "./components/HeadTopComment";
export default {
  name: "CommentManageDetail",
  components: {
    HeadTitle,
  },
  data() {
    return {
      url: "/commentManage",
      list: [],
      listData: [],
      showPopup: false,
      circle: "小迪播报",
      selectList: [],
      showCircle: false,
      textMess: "",
      comment_authorid: "",
      img: "",
      uid: "",
      ispinglun: false,
      isStatus: false,
    };
  },
  computed: {
    pid() {
      let pid = this.$route.query?.pid || "";
      return pid;
    },
  },
  created() {
    this.img = this.$route.query?.img;
    this.uid = this.$route.query?.uid;
    if (this.$route.query.reply_type === "01") {
      this.ispinglun = true;
    }
    if (this.$route.query.invisible === "01") {
      this.isStatus = true;
    }
  },
  mounted() {
    this.getList();
    let selectList = JSON.parse(localStorage.getItem("pgcList"));
    if (selectList?.length > 0) {
      this.circle = selectList[0].name;
      this.comment_authorid = selectList[0].value;
      this.selectList = selectList;
    }
  },
  methods: {
    caseFieldValue() {
      let state = this.$route.query?.invisible;
      const stateList = {
        "01": "待审核",
        "02": "仅自己可见",
        "03": "审核通过",
        "04": "审核不通过",
        "05": "精选",
      };
      return stateList[state] ? stateList[state] : "";
    },
    caseFieldColorValue() {
      let state = this.$route.query?.invisible;
      const stateList = {
        "03": "rgb(0, 193, 0)",
        "01": "#d6d62f",
        "05": "rgb(0, 193, 0)",
      };
      return stateList[state] ? stateList[state] : "red";
    },
    // 主评论
    getList() {
      const params = {
        comment_id: this.$route.query?.comment_id,
        reply_type: this.$route.query?.reply_type,
        pid: this.$route.query?.pid,
      };
      console.log(params);
      replylistForumCommentAPI(params).then((res) => {
        if (res.status === 200) {
          this.list = res.data || [];
          this.listData = res.data[0].list || [];
        }
      });
    },
    // 删除
    deleteCom(item, status) {
      Dialog.confirm({
        title: "删除评论",
        message: "你确定要删除该条评论吗?",
        // theme: "round-button",
      })
        .then(() => {
          console.log(item, status, deleteReplyForumCommentAPI);
          const data = {
            cid: this.$route.query?.comment_id,
            comment_author_type: "1",
            pid: this.pid,
            "delete[0]": item.id,
            comment_authorid: item.uid,
            replyType: "01",
          };
          deleteReplyForumCommentAPI(data).then((res) => {
            if (res.data.status === 1) {
              Toast.success(res.data.info);
              if (status) {
                this.$router.push({
                  path: "/commentManage",
                  query: { source: "commentDetail" },
                });
              } else {
                this.getList();
              }
            } else {
              Toast.fail(res.data.info);
            }
            console.log(res, "111");
          });
        })
        .catch(() => { });
    },
    // 评论
    comment() {
      this.showPopup = true;
    },
    // 不通过
    fail() {
      Dialog.confirm({
        title: "评论审核",
        message: "是否确认不通过该评论内容?",
      })
        .then(() => {
          this.state = "approved";
          const data = {
            id: this.$route.query?.comment_id,
            status: "01",
            discuzId: this.$route.query?.uid,
            originalType: "01",
            newType: "04",
          };
          commentauditForumCommentAPI(data).then((res) => {
            if (res.data.status === 1) {
              Toast.success(res.data.info);
            } else {
              Toast.fail(res.data.info);
            }
          });
        })
        .catch(() => { });
    },
    // 通过
    pass() {
      Dialog.confirm({
        title: "评论审核",
        message: "是否确认通过该评论内容?",
      })
        .then(() => {
          this.state = "approved";
          const data = {
            id: this.$route.query?.comment_id,
            status: "01",
            discuzId: this.$route.query?.uid,
            originalType: "01",
            newType: "03",
          };
          commentauditForumCommentAPI(data).then((res) => {
            if (res.data.status === 1) {
              Toast.success(res.data.info);
            } else {
              Toast.fail(res.data.info);
            }
          });
        })
        .catch(() => { });
    },
    onSelect(item) {
      console.log(item, "item1");
      this.showCircle = false;
      this.circle = item.name;
      this.comment_authorid = item.value;
    },
    cancelCircle() {
      this.showPopup = false;
      this.circle = "小迪播报";
      this.textMess = "";
    },
    oKCircle() {
      const data = {
        cid: this.$route.query?.comment_id,
        comment_author_type: "2",
        pid: this.pid,
        comment_authorid: this.comment_authorid,
        comment_content: this.textMess,
        replyType: "01",
      };
      if (data.comment_authorid === "") {
        Toast.fail("请选择PCG账号！");
        return;
      }
      if (data.comment_content === "") {
        Toast.fail("请输入评论内容！");
        return;
      }
      addCommentAPI(data).then((res) => {
        if (res.data.status === 1) {
          Toast.success(res.data.info);
          this.cancelCircle();
          this.getList();
        } else {
          Toast.fail(res.data.info);
        }
        console.log(res, "111");
      });
    },
    goViewPost() {
      this.$router.push({
        path: "/viewPost",
        query: { pid: this.pid },
      });
    },
  },
};
</script>
<style scoped lang="less">
.commentDetail {
  height: 100%;
  width: 100%;

  .topBox {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    height: 60px;
    font-size: 26px;

    .text {
      background: white;
      width: 20%;
      height: 60px;
      line-height: 60px;
      text-align: center;
      border: 1px solid #179ad2;
      color: #179ad2;
      margin: 20px 30px 20px 0px;
    }
  }

  .box {
    padding: 0px 30px;
    // height: 260px;
    margin: 32px 0px;
    border-bottom: 2px solid #ececec;

    .contentBottom {
      margin-top: 16px;
      font-size: 26px;
    }
  }

  .topRow {
    display: flex;
    justify-content: space-between;

    .topRowLeft {
      display: flex;
      align-items: center;
      justify-content: flex-start;

      .touXiangImg {
        width: 100px;
        height: 100px;
        border-radius: 50%;
      }

      .headLeft {
        margin-left: 30px;

        .name {
          font-weight: 500;
          font-size: 28px;
        }

        .car {
          padding: 0px 12px;
          color: #b77d43;
          background-color: #f4f0e4;
          width: 105px;
          height: 40px;
          font-size: 24px;
          text-align: center;
          border-radius: 32px;
          margin-top: 8px;
        }

        .uid {
          margin-top: 6px;
        }
      }
    }

    .topRowRight {
      color: red;
      font-size: 24px;
      margin-top: 10px;
    }
  }

  .content {
    font-size: 30px;
    color: #969799;
    margin: 12px 0px;
  }

  .timeBox {
    display: flex;
    justify-content: space-between;
    height: 80px;
    align-items: center;
    font-size: 26px;
    color: #969799;

    .operation {
      display: flex;

      // justify-content: flex-end;
      div {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-left: 16px;

        .listFooterRightImg {
          width: 50px;
          height: 50px;
        }

        .listFooterRightNum {
          display: inline-block;
          margin-left: 8px;
          height: 50px;
          line-height: 50px;
        }
      }
    }
  }

  .btnBoottom {
    position: fixed;
    // left: 12px;
    right: 0;
    bottom: 36px;
    z-index: 5;
    width: 100%;
    height: 80px;

    .operationBtn {
      display: flex;
      background: white;
      line-height: 80px;
      justify-content: space-around;

      div {
        font-size: 30px;
        width: 24%;
        text-align: center;
        border: 1px solid rgb(72, 113, 192);
        margin: 0px 12px;
      }

      .btn1 {
        background: white;
        color: rgb(72, 113, 192);
      }

      .btn2 {
        background: rgb(72, 113, 192);
        color: white;
      }
    }
  }

  .commonPop {
    .titleTop {
      height: 120px;
      line-height: 120px;
      font-size: 40px;
      text-align: center;
    }

    .text {
      width: 100%;
      height: 40px;
      display: flex;

      span {
        margin-left: 20px;
        font-size: 32px;
      }
    }

    .btnRow {
      display: flex;
      justify-content: space-around;
      margin-top: 8px;
    }
  }

  .replyBox {
    width: 100%;
    height: 30px;
    font-size: 32px;

    span {
      margin-left: 32px;
      font-weight: 600;
    }
  }

  .name {
    color: #eb7350;
  }
}
</style>